module.exports = {
	"id": "CM",
	"name": "Cameroon",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.007671,
			"5": 0.002557,
			"6": null,
			"7": 0.005114,
			"8": 0.002557,
			"9": null,
			"10": 0.005114,
			"11": 0.056254,
			"12": 0.017899,
			"13": 0.012785,
			"14": 0.002557,
			"15": 0.002557,
			"16": 0.007671,
			"17": 0.002557,
			"18": 0.005114,
			"19": 0.010228,
			"20": null,
			"21": null,
			"22": 0.005114,
			"23": 0.012785,
			"24": null,
			"25": 0.015342,
			"26": 0.012785,
			"27": 0.007671,
			"28": 0.05114,
			"29": 0.033241,
			"30": 0.010228,
			"31": 0.030684,
			"32": 0.005114,
			"33": 0.023013,
			"34": 0.007671,
			"35": 0.043469,
			"36": 0.015342,
			"37": 0.002557,
			"38": 0.010228,
			"39": 0.02557,
			"40": 0.02557,
			"41": 0.002557,
			"42": 0.015342,
			"43": 0.184104,
			"44": 0.007671,
			"45": 0.063925,
			"46": 0.053697,
			"47": 0.035798,
			"48": 0.035798,
			"49": 0.652035,
			"50": 0.053697,
			"51": 0.324739,
			"52": 0.135521,
			"53": 4.461965,
			"54": 1.247816,
			"55": 0.030684,
			"56": 0.015342,
			"57": null
		},
		"firefox": {
			"2": 0.012785,
			"3": 0.120179,
			"4": 0.012785,
			"5": 0.007671,
			"6": 0.005114,
			"7": 0.005114,
			"8": 0.005114,
			"9": 0.005114,
			"10": 0.012785,
			"11": 0.107394,
			"12": 0.035798,
			"13": 0.012785,
			"14": 0.012785,
			"15": 0.023013,
			"16": 0.023013,
			"17": 0.017899,
			"18": 0.010228,
			"19": 0.033241,
			"20": 0.046026,
			"21": 0.048583,
			"22": 0.020456,
			"23": 0.023013,
			"24": 0.043469,
			"25": 0.038355,
			"26": 0.030684,
			"27": 0.028127,
			"28": 0.023013,
			"29": 0.071596,
			"30": 0.089495,
			"31": 0.084381,
			"32": 0.038355,
			"33": 0.069039,
			"34": 0.05114,
			"35": 0.094609,
			"36": 0.097166,
			"37": 0.120179,
			"38": 0.186661,
			"39": 0.071596,
			"40": 0.125293,
			"41": 0.145749,
			"42": 0.117622,
			"43": 0.848924,
			"44": 0.263371,
			"45": 0.240358,
			"46": 0.181547,
			"47": 1.135308,
			"48": 1.038142,
			"49": 5.425954,
			"50": 0.375879,
			"51": 0.053697,
			"52": 0.007671,
			"3.5": 0.028127,
			"3.6": 0.038355
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.002557,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.002557,
			"19": 0.005114,
			"20": 0.002557,
			"21": null,
			"22": 0.002557,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.007671,
			"29": 0.015342,
			"30": 0.005114,
			"31": 0.005114,
			"32": 0.005114,
			"33": 0.007671,
			"34": 0.012785,
			"35": 0.012785,
			"36": 0.048583,
			"37": 0.117622,
			"38": 0.020456,
			"39": 0.030684,
			"40": 0.373322,
			"41": 0.056254,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.005114,
			"11.6": 0.005114,
			"12.1": 0.010228
		},
		"safari": {
			"0": null,
			"4": 0.002557,
			"5": 0.005114,
			"6": 0.012785,
			"7": 0.002557,
			"8": 0.035798,
			"9": 0.020456,
			"10": 0.086938,
			"3.1": null,
			"3.2": null,
			"5.1": 0.015342,
			"6.1": 0.002557,
			"7.1": 0.005114,
			"9.1": 0.161091
		},
		"ios_saf": {
			"8": 0,
			"10": 0.758113860949,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0204302913197,
			"8.1-8.4": 0.0377440975229,
			"9.0-9.2": 0.0180063584513,
			"9.3": 0.274712391757
		},
		"android": {
			"3": 0,
			"4": 0.170708186047,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0213385232558,
			"4.1": 0.615768813953,
			"4.2-4.3": 1.53942203488,
			"4.4": 3.5300014186,
			"4.4.3-4.4.4": 3.56048502326
		},
		"ie": {
			"6": 0.0105297109145,
			"7": 0.0289567050147,
			"8": 0.168475374631,
			"9": 0.034221560472,
			"10": 0.0605458377581,
			"11": 0.589663811209,
			"5.5": null
		},
		"op_mob": {
			"0": 2.04391667247,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0567754631241
		},
		"edge": {
			"12": 0.086938,
			"13": 0.117622,
			"14": 0.138078
		},
		"ie_mob": {
			"10": 0.25536828169,
			"11": 1.03971371831
		},
		"bb": {
			"7": 0.06884775,
			"10": null
		},
		"samsung": {
			"0": 1.04202
		},
		"and_uc": {
			"0": 11.797155
		},
		"op_mini": {
			"0": 27.5373338644
		},
		"and_chr": {
			"0": 21.52489
		},
		"and_ff": {
			"0": 0.141417
		}
	},
	"total": 97.95743075
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CM.json
 ** module id = 497
 ** module chunks = 0
 **/